import { Component } from '@angular/core';

@Component({
    selector: 'app-health-help',
    templateUrl: './health-help.component.html',
    styleUrls: ['./health-help.component.scss']
})
export class HealthHelpComponent {
    nutritionArticleLinks = [
        { title: "What are whole foods?", source: "British Heart Foundation, 2024", url: "https://www.bhf.org.uk", urlText: "https://www.bhf.org.uk" },
        { title: "Healthier Gut", source: "British Dietetic Association, 2021", url: "https://www.bda.uk.com/", urlText: "https://www.bda.uk.com/" },
        { title: "A healthy balanced diet", source: "British Nutrition Foundation, 2024", url: "https://www.nutrition.org.uk", urlText: "https://www.nutrition.org.uk" },
        { title: "UPFs linked to 10% higher death risk", source: "Food Manufacture, 2024", url: "https://www.foodmanufacture.co.uk", urlText: "https://www.foodmanufacture.co.uk" },
        { title: "Artificial sweeteners", source: "Nutritionist Resource, 2024", url: "https://www.mdpi.com", urlText: "https://www.mdpi.com" },
        { title: "Olive oil could cut risk of heart disease", source: "British Heart Foundation, 2014", url: "https://www.bhf.org.uk", urlText: "https://www.bhf.org.uk" },
        { title: "More Energy", source: "British Dietetic Association, 2021", url: "https://www.bda.uk.com", urlText: "https://www.bda.uk.com" },
        { title: "Better Mood and Clarity", source: "University of Warwick, 2024", url: "https://www.sciencedaily.com/releases/2024/04/240424111638.htm", urlText: "https://www.sciencedaily.com" },
        { title: "Reduced Cravings", source: "NHS Inform, 2024", url: "https://www.nhsinform.scot", urlText: "https://www.nhsinform.scot" },
        { title: "Better Sleep", source: "British Heart Foundation, 2024", url: "https://www.nutrition.org.uk", urlText: "https://www.nutrition.org.uk" }
    ];

    getColumns() {
        const mid = Math.ceil(this.nutritionArticleLinks.length / 2);
        return [
            this.nutritionArticleLinks.slice(0, mid),
            this.nutritionArticleLinks.slice(mid)
        ];
    }
}
